/* eslint-disable react/no-render-return-value */
/* eslint-disable import/newline-after-import */
import React from 'react';
import ReactDOM from 'react-dom';

import { ELEMENT_ID } from './constants';
import App from './App';

class WebComponent extends HTMLElement {
  connectedCallback() {
    const componentType = this.getAttribute('componentType');
    ReactDOM.render(<App componentType={componentType} />, this);
  }
}

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
